import { useLang } from "@/context/LanguageContext";
import { waLink } from "@/lib/content";
import { Reveal } from "@/components/site/Reveal";

export const TourCard = ({ tour, index, featuredLabel }) => {
  const { t } = useLang();
  return (
    <Reveal delay={index * 0.1}>
      <article
        data-testid={`tour-card-${index}`}
        className={`group flex h-full flex-col border bg-canvas ${tour.featured ? "border-teak" : "border-navy/10"}`}
      >
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={tour.img}
            alt={tour.name}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <span className="absolute left-4 top-4 bg-navy px-3 py-1.5 text-[10px] uppercase tracking-[0.2em] text-canvas">
            {tour.tag}
          </span>
          {tour.featured && (
            <span
              data-testid={`tour-featured-${index}`}
              className="absolute right-4 top-4 bg-gold px-3 py-1.5 text-[10px] uppercase tracking-[0.2em] text-navy font-semibold"
            >
              {featuredLabel}
            </span>
          )}
        </div>

        <div className="flex flex-1 flex-col p-7 md:p-9">
          <h3 className="font-serif text-3xl md:text-4xl text-navy">{tour.name}</h3>
          <p className="mt-4 font-light leading-relaxed text-navy/70">{tour.desc}</p>

          <ul className="mt-6 space-y-2">
            {tour.bullets.map((b) => (
              <li key={b} className="flex items-center gap-3 text-sm text-navy/80">
                <span className="text-gold">—</span> {b}
              </li>
            ))}
          </ul>

          <div className="mt-8 flex items-center justify-between border-t border-navy/10 pt-6">
            <p className="text-xs uppercase tracking-[0.15em] text-navy/50 max-w-[55%]">{tour.duration}</p>
            <a
              href={waLink(`${t.waMsg} (${tour.name})`)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`tour-book-${index}`}
              className="inline-flex items-center gap-2 rounded-full border border-navy px-5 py-3 text-xs uppercase tracking-[0.15em] font-medium text-navy transition-colors hover:bg-navy hover:text-canvas whitespace-nowrap"
            >
              {t.nav.book} →
            </a>
          </div>
        </div>
      </article>
    </Reveal>
  );
};
